export default {
  computed: {
    isDesktop() {
      return this.$mq !== "mobile" && this.$mq !== "tablet";
    }
  }
};
